import { useState, useCallback } from 'react';

export const useSalesEnrollment = () => {
    const [pendingEnrollments, setPendingEnrollments] = useState({});
    const [showEnrollmentCartId, setShowEnrollmentCartId] = useState(null);

    const clearEnrollmentsForCartId = useCallback((cartId) => {
        setPendingEnrollments(p => {
            const c = { ...p };
            delete c[cartId];
            return c;
        });
        setShowEnrollmentCartId(curr => curr === cartId ? null : curr);
    }, []);

    return { 
        pendingEnrollments, 
        setPendingEnrollments, 
        showEnrollmentCartId, 
        setShowEnrollmentCartId, 
        clearEnrollmentsForCartId 
    };
};
